define(['underscore'], (_)=> {
    return ['ModalService', '$filter', '$state', 'state_plugin_config','$stateParams', (ModalService, $filter, $state, statePluginConfig,$stateParams)=> {
        return {
            isInputValid: (inputs)=> {
                const regex =  /^[A-Za-z0-9)(\":#\\\/&`', ._-]+$/
                let isValid = true;
                let inValidInputs = [];
                for(var i = 0; i < inputs.length; i++){
                    if(Object.values(inputs[i]).toString() && !regex.test(Object.values(inputs[i]).toString())){
                        inValidInputs.push(Object.keys(inputs[i]).toString())
                        isValid = false                       
                    }
                }
                return [isValid, inValidInputs]
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/services/InputValidationService.js
 **/